import { useTheme } from "styled-components";
import { TextField as ElementTextField } from "@ovotech/element";
import React, { ChangeEvent, Ref } from "react";
import { useField } from "_core/form";

type Props = Partial<React.ComponentProps<typeof ElementTextField>> & {
  label: string;
  value: any;
  name: string;
  id: string;
  "data-testid"?: string;
};

export const TextField = React.forwardRef(
  (
    { label, id, hint, name, value, ...rest }: Props,
    ref: Ref<HTMLInputElement> | undefined
  ) => {
    const theme = useTheme();

    const {
      meta: { error, touched },
      helpers: { setValue, setTouched },
    } = useField<string>(name);

    return (
      <ElementTextField
        style={{ marginTop: theme.space["50"] }}
        {...rest}
        ref={ref}
        label={label}
        name={name}
        id={id}
        value={value}
        hint={hint}
        onChange={(
          event: ChangeEvent<HTMLInputElement> &
            ChangeEvent<HTMLSelectElement> &
            ChangeEvent<HTMLTextAreaElement>
        ) => {
          if (rest.onChange) {
            rest.onChange(event);
          } else {
            setValue(event.target.value);
          }
        }}
        onBlur={() => setTouched(true)}
        error={
          error &&
          touched && (
            <div
              data-testid={
                rest["data-testid"]
                  ? `${rest["data-testid"]}-error`
                  : `${name}-field-error`
              }
            >
              {error}
            </div>
          )
        }
      />
    );
  }
);

TextField.displayName = "TextField";
